export const API_HOST_WMS = "baseUrl";
export const API_HOST_POD = "podBaseUrl";
export const API_HOST_HP = "hpBaseUrl";
export const API_HOST_HP_INTERNAL = "hpInternalBaseUrl";

const config = {
  development: {
    [API_HOST_POD]: "https://devpod.hyperpure.com/",
    [API_HOST_WMS]: "https://hpadminpod.zomans.com/",
    [API_HOST_HP]: "https://dev.hyperpure.com/",
    [API_HOST_HP_INTERNAL]: "http://localhost:1222",
  },
  staging: {
    [API_HOST_POD]: "https://devpod.hyperpure.com/",
    [API_HOST_WMS]: "https://hpadminpod.zomans.com/",
    [API_HOST_HP]: "https://hyperpure.com/",
    [API_HOST_HP_INTERNAL]: "https://devapi.hyperpure.com",
  },
  production: {
    [API_HOST_POD]: "https://pod.hyperpure.com",
    [API_HOST_WMS]: "https://prodhpadmin.zomans.com/",
    [API_HOST_HP]: "https://hyperpure.com",
    [API_HOST_HP_INTERNAL]: "https://api.hyperpure.com",
  },
};

let apiEndpoint = "";
if (process.env.REACT_APP_API_ENDPOINT) {
  apiEndpoint = config[process.env.REACT_APP_API_ENDPOINT];
} else {
  apiEndpoint = config[process.env.NODE_ENV];
}

export default apiEndpoint;
